"use client";

import RegisterLessonForm from "@/app/components/LessonRegistrationForm";
import LessonList from "@/app/components/LessonList";
import MonthlySummary from "@/app/components/MonthlySummary";
import { useState } from "react";
import type { Lesson } from "@prisma/client";

interface WorkLogClientProps {
	allLessons: Lesson[];
}

function MonthlyLog(props: { lessonsOnDisplayMonth: Lesson[]; month: string }) {
	if (props.lessonsOnDisplayMonth.length === 0) {
		return (
			<div className="mt-32 text-center text-2xl font-bold">
				{props.month}の授業はありません
			</div>
		);
	} else {
		return (
			<div>
				<MonthlySummary
					lessonsOnDisplayMonth={props.lessonsOnDisplayMonth}
				/>
				<h2 className="pt-6 text-center text-3xl font-bold">
					{props.month}の授業一覧
				</h2>
				<LessonList lessonsOnDisplayMonth={props.lessonsOnDisplayMonth} />
			</div>
		);
	}
}

export default function WorkLogClient(props: WorkLogClientProps) {
	const [displayMonth, setDisplayMonth] = useState(new Date());

	const lessonsOnDisplayMonth = props.allLessons.filter((lesson) => {
		const lessonMonth = lesson.startTime.getMonth();
		const lessonYear = lesson.startTime.getFullYear();
		return (
			lessonMonth === displayMonth.getMonth() &&
			lessonYear === displayMonth.getFullYear()
		);
	});

	const today = new Date();
	const thisYear = today.getFullYear();
	const targetMonth = displayMonth.getMonth() + 1;
	const targetYear = displayMonth.getFullYear();

	const month =
		thisYear === targetYear
			? `${targetMonth}月`
			: `${targetYear}年${targetMonth}月`;

	return (
		<div className="flex min-h-screen flex-col gap-5 bg-gray-50 p-4 text-black lg:flex-row">
			<div className="order-2 w-full lg:order-1 lg:w-1/2">
				<div className="flex-col items-center justify-center">
					<div className="flex justify-between px-1 pt-6 lg:px-6">
						<button
							onClick={() => {
								const prevMonth = new Date(displayMonth);
								prevMonth.setMonth(prevMonth.getMonth() - 1);
								setDisplayMonth(prevMonth);
							}}
							className="rounded-md bg-blue-500 px-4 py-2 text-white transition-colors duration-200 hover:bg-blue-800"
						>
							前の月
						</button>
						<h2 className="pt-1 text-3xl font-bold">{month}の勤務</h2>
						<button
							onClick={() => {
								const prevMonth = new Date(displayMonth);
								prevMonth.setMonth(prevMonth.getMonth() + 1);
								setDisplayMonth(prevMonth);
							}}
							className="rounded-md bg-blue-500 px-4 py-2 text-white transition-colors duration-200 hover:bg-blue-800"
						>
							次の月
						</button>
					</div>
					<MonthlyLog
						lessonsOnDisplayMonth={lessonsOnDisplayMonth}
						month={month}
					/>
				</div>
			</div>
			<RegisterLessonForm />
		</div>
	);
}
